import { render } from "./SideDashboardMenuComponent.vue?vue&type=template&id=9bc80022"
import script from "./SideDashboardMenuComponent.vue?vue&type=script&lang=js"
export * from "./SideDashboardMenuComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__